// 其他信息面板 - 简体中文
export default {
  tabs: {
    imtoken: "imtoken操作信息",
    tokenPocket: "TokenPocket登录信息",
    bitpie: "Bitpie自定义标签",
  },
  loading: { text: "拼命加载中" },
  total: {
    prefix: "共计",
    suffix: "条数据",
  },
  actions: {
    download: "下载",
  },
  table1: {
    operationType: "操作类型",
    operationTypeExplain: "操作类型说明",
    ip: "IP地址",
    ipGeo: "IP地理位置",
    operateTime: "操作时间",
  },
  table2: {
    loginDevice: "登录设备",
    ipAddress: "IP地址",
    port: "端口",
    ipGeo: "IP地理位置",
    operateTime: "操作时间",
  },
  dialog: {
    titleImTokenExplain: "imToken钱包的操作类型说明",
  },
  empty: "暂无数据",
  downloadFileName: "TokenPocket登录信息",
};
